import type { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { isImageSkuCode } from '@wds/astro-bot-shared/catalog';
import { useImageFeatures } from '../hooks/useImageFeatures';

type Props = { fallback: string; children: ReactNode };

export function ImageFeatureRoute({ fallback, children }: Props): JSX.Element | null {
  const { enabled, ready } = useImageFeatures();
  if (!ready) return null;
  return enabled ? <>{children}</> : <Navigate to={fallback} replace />;
}

export function ImageSkuRoute({ fallback, children }: Props): JSX.Element | null {
  const { code = '' } = useParams<{ code: string }>();
  const { enabled, ready } = useImageFeatures();
  if (!isImageSkuCode(code)) return <>{children}</>;
  if (!ready) return null;
  return enabled ? <>{children}</> : <Navigate to={fallback} replace />;
}
